import * as React from "react";
import { Row, Col, Label } from "reactstrap";
import { formatCapitalized, momentAgeNow, momentToString } from "src/share/utils/utils";
import { By } from 'src/share/types/visualSearch';

export interface IInformationPersonCardProps {
  caseId: string;
  person: any;
  personType: string;
  history?: any;
}

export class InformationPersonCard extends React.Component<IInformationPersonCardProps> {
  public NO_PHOTO_FOUND = "https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg";
  constructor(props: IInformationPersonCardProps) {
    super(props);
    this.state = {
      personType: ""
    };
  }
  public visualSearchText = image => {
    return image && <p onClick={() => this.redirectToVisualSearch(image)}>
      Visual Search <span className="fa fa-search" aria-hidden="true" />
    </p>
  }
  public redirectToVisualSearch = image => {
    return image && this.props.history.push({
      pathname: "/rekognition/visualsearch",
      state: { image, by: By.URL }
    })
  }
  public render() {
    const { person, personType } = this.props;
    return (
      <div className="card white-background">
        <div className="container-fluid">
          <Row>
            <Col className="col-md-4 images-container">
              <Row>
                <Col className="col-md-12">
                  <div className="person-background portrait">
                    <img
                      src={person.images && person.images[0] ? person.images[0] : this.NO_PHOTO_FOUND}
                      alt="portrait"
                      onClick={() => this.redirectToVisualSearch(person.images[0])}
                    />
                    {this.visualSearchText(person.images[0])}
                  </div>
                </Col>
              </Row>
              {person.images && (person.images[1] || person.images[2]) ? (
                <Row className="person-secondary-images-row">
                  <Col className="col-md-6 person-background-column">
                    <div className="person-background alternate">
                      <img
                        src={person.images[1] ? person.images[1] : this.NO_PHOTO_FOUND}
                        alt="alternate"
                        onClick={() => this.redirectToVisualSearch(person.images[1])}
                      />
                      {this.visualSearchText(person.images[1])}
                    </div>
                  </Col>
                  <Col className="col-md-6 person-background-column">
                    <div className="person-background progressed">
                      <img
                        src={person.images[2] ? person.images[2] : this.NO_PHOTO_FOUND}
                        alt="progressed"
                        onClick={() => this.redirectToVisualSearch(person.images[2])}
                      />
                      {this.visualSearchText(person.images[2])}
                    </div>
                  </Col>
                </Row>
              ) : (
                <></>
              )}
            </Col>
            <Col className="col-md-8 information-container">
              <Row>
                <Col className="col-md-12">
                  <h1>{formatCapitalized(person.fullName)}</h1>
                  {personType === "children" && (
                    <p className="person-case-id">
                      <Label>Case ID:</Label>
                      {this.props.caseId}
                    </p>
                  )}
                  <p className="person-birthday">
                    <Label>Birthday:</Label>
                    {person.birthDate && (person.birthDate as any).isValid()
                      ? `${momentToString(person.birthDate)} (${momentAgeNow(person.birthDate)}  years)`
                      : "Unknown"}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="col-md-6">
                  <div className="person-details">
                    <p>
                      <Label>Sex:</Label>
                      {person.sex || "Unknown"}
                    </p>
                    <p>
                      <Label>Weight:</Label>
                      {person.weight && person.weightUnit ? `${person.weight} ${person.weightUnit}` : "Unknown"}
                    </p>
                    <p>
                      <Label>Height:</Label>
                      {person.height && person.heightUnit ? `${person.height} ${person.heightUnit}` : "Unknown"}
                    </p>
                  </div>
                </Col>
                <Col className="col-md-6">
                  <div className="person-details">
                    {personType === "companions" && (
                      <p className="person-case-id">
                        <Label>Companion type:</Label>
                        {person.companionType ? formatCapitalized(person.companionType) : "Unknown"}
                      </p>
                    )}
                    <p>
                      <Label>Eye color:</Label>
                      {person.eyeColor || "Unknown"}
                    </p>
                    <p>
                      <Label>Hair color:</Label>
                      {person.hairColor || "Unknown"}
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/Person/components/InformationPersonCard.tsx